import {
  QA_NAME_CANCEL_BTN,
  QA_NAME_CONFIRM_BTN,
  QA_NAME_REMOVE_BTN,
} from '../../../../constants/qa'
import { Buttons } from '../../../Modal'
import {
  TableModalButtonCancel,
  TableModalButtonConfirm,
} from '../../../TableModal'

//in the next version the actions will be replaced by the Confirm button and a dropdown with actions

function Actions({
  ButtonCancel = TableModalButtonCancel,
  ButtonConfirm = TableModalButtonConfirm,
  ButtonConfirmRemove = TableModalButtonConfirm,
  Component = Buttons,
  buttonCancelProps,
  buttonConfirmProps,
  buttonRemoveProps,
  children,
  componentProps,
  isSkeleton,
  readonly,
}) {
  return (
    <Component {...componentProps} size='l'>
      {ButtonConfirm && readonly ? (
        <ButtonConfirm
          {...buttonConfirmProps}
          isSkeleton={isSkeleton}
          qaName={QA_NAME_CONFIRM_BTN}
          text='Modal.ConfirmBtnKey'
        />
      ) : null}
      {ButtonConfirmRemove && !readonly ? (
        <ButtonConfirmRemove
          {...buttonRemoveProps}
          isSkeleton={isSkeleton}
          qaName={QA_NAME_REMOVE_BTN}
          text='Modal.AttachedFilesRemoveBtnKey'
        />
      ) : null}
      {ButtonCancel && !readonly ? (
        <ButtonCancel
          {...buttonCancelProps}
          isSkeleton={isSkeleton}
          qaName={QA_NAME_CANCEL_BTN}
        />
      ) : null}
      {children}
    </Component>
  )
}

export default Actions
